import { useTranslation } from 'react-i18next';
/**
 * Loads translations for this library with proper type checking.
 */
export function useAlertUiTranslation() {
    return useTranslation('alert-ui');
}
